<div class="patient-banner__container flex"
     [ngClass]="{
     'patient-banner__container--skinny': type === 'skinny',
     'patient-banner__container--compressed': isCompressed,
     'patient-banner__container--collapsible': isCollapsible,
     'patient-banner__container--stacked': isStacked,
     'patient-banner--dark': isDarkTheme,
     'patient-banner__container--no-icon': isIconHidden
     }">
  <div class="patient-banner">
    <svg-icon name="ico-patient-24"
              class="patient-banner__icon"
              [ngClass]="{'patient-banner__icon--hidden': isIconHidden}"
              [svgStyle]="{ 'width.px': '24', 'height.px': '24', 'fill': 'currentColor' }">
    </svg-icon>
    <div class="flex">
      <!-- Patient Name -->
      <div class="flex flex--nowrap flex--row">
        <span class="patient-banner__name text-ellipsis" *ngIf="isDropdownHidden && patient"
              [tooltip]="patient.label" [overflowOnly]="true">
          {{patient.label}}
        </span>
        <wfm-select-dropdown
          class="patient-banner__select"
          *ngIf="!isDropdownHidden"
          [placeholder]="placeholder"
          columns="1"
          [required]="true"
          [search]="true"
          labelField="label"
          [items]="patientsList"
          [(value)]="patient"
          (valueChange)="onItemSelected($event)"
        ></wfm-select-dropdown>
      </div>

      <!-- Patient I Name -->
      <div class="flex flex--nowrap flex--row" *ngIf="patient?.localLabel">
        <span class="patient-banner__name text-align--left text-ellipsis"
              [tooltip]="patient.localLabel" [overflowOnly]="true" dir="auto">
          {{patient.localLabel}}
        </span>
      </div>
    </div>
  </div>
  <!-- patient data -->
  <dl *ngIf="patient" class="patient-banner__content flex flex--wrap u--1/1 u-pl----"
      [ngClass]="{'patient-banner__content--compressed': isCompressed, 'u-ml--': isCompressed && isIconHidden}">
    <ng-container *ngFor="let datas of patient.data">
      <ng-container *ngFor="let data of datas | keyvalue: returnZero">
        <div class="patient-banner__data" aria-hidden="false" [ngClass]="{'u--small-1/4 u--smallest-1/3 patient-banner__data--column': isColumns}">
          <dt class="patient-banner__value text-16" [ngClass]="{'patient-banner__value--column': isColumns}">{{data.key}}</dt>
          <dd class="patient-banner__value--bold text-bold-16" [ngClass]="{'patient-banner__value--column': isColumns}" title="{{data.value}}">{{data.value}}</dd>
        </div>
      </ng-container>
    </ng-container>
  </dl>

  <svg-icon
    *ngIf="patient && isCollapsible && isCollapsed"
    name="ico-caret-down-16"
    class="patient-banner__icon--collapsible"
    [attr.data-selected]="isPatientSelected"
    [ngClass]="{'patient-banner__icon--hidden': isIconHidden}"
    [svgStyle]="{ 'width.px': '16', 'height.px': '16','fill': 'currentColor' }"
    (click)="onIconClick()">
  </svg-icon>
  <svg-icon
    *ngIf="patient && isCollapsible && !isCollapsed"
    name="ico-caret-up-16"
    class="patient-banner__icon--collapsible"
    [attr.data-selected]="isPatientSelected"
    [ngClass]="{'patient-banner__icon--hidden': isIconHidden}"
    [svgStyle]="{ 'width.px': '16', 'height.px': '16', 'fill': 'currentColor' }"
    (click)="onIconClick()">
  </svg-icon>
</div>
